import { Component, OnInit, ViewChild } from '@angular/core';
import { MemberService } from "app/member/member.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastsManager } from "ng2-toastr";
import { LookupService } from "app/webservice/lookup.service";

@Component({
  selector: 'app-member-add',
  templateUrl: './member-add.component.html',
  styleUrls: ['./member-add.component.css']
})
export class MemberAddComponent implements OnInit {

  genders = [];

  public member = {
    FirstName: '',
    LastName: '',
    BarcodeId: '',
    MemberId: '',
    DepositYN: false,
    FullName: '',
    Email: '',
    Phones: [
      {Number: '', IsPrimary: true, lkpPhoneTypeOid: 0}, 
      {Number: '', IsPrimary: false, lkpPhoneTypeOid: 0}
    ],
    EmailOptOut: false,
    Identifier: '',
    IsActive: true,
    lkpGenderOid: 0,
    Gender: '',
    Note: '',
    Salutation: '',
    Addresses: [
      {Street: '', City: '', State: '', Zip: '', lkpAddressTypeOid: 2679, IsPrimary: true}, 
      {Street: '', City: '', State: '', Zip: '', lkpAddressTypeOid: 2680, IsPrimary: false}
    ]
  }

  constructor(
    private route: Router, 
    private _toast: ToastsManager, 
    private _lookup: LookupService, 
    private _memberService: MemberService
  ) {
    this.genders = this._lookup.findLookupByLookupName('Gender');
  }

  @ViewChild('scannerInput') scannerInput;
  @ViewChild('MemberModal') MemberModal;
  @ViewChild('notes') notes;

  ngOnInit() {
  }

  EnterBarcode() {
    console.log("Bring up barcode modal for Member");
    this.MemberModal.show();
    setTimeout(() => {
      $('#scannerInput').focus();
    }, 500);
  }

  validatePhone(phone) {
    this.member.Phones[0].Number = this._memberService.formatPhone(phone);
  }

  validateAltPhone(altPhone) {
    this.member.Phones[1].Number = this._memberService.formatPhone(altPhone);
  }

  saveMember() {
    this._memberService.AddEditMember(this.member).then(response => {
      console.log(response);
      if (response.Member && response.Success) {
        this.MemberModal.hide();
        this._toast.success('Member saved');
        this.route.navigate(['/member/' + response.Member.Oid]);
      } else {
        // TODO: add error saying member add failed
        this._toast.error('Error saving new member');
      }
    })
  }

}





// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/member-add/member-add.component.ts